<template>
  <div style="background: white" class="p-6 laptop:p-4 mobile:p-2">
    <div class="head flex justify-between mt-2">
      <div class="flex items-center">
        <i class="el-icon-tickets" />
        <span class="pl-4" style="color: #82889c; font-size: 13px">
          {{ $t("menu.quantity") }}
        </span>
      </div>
      <div>
        <el-button v-if="link && shouldDisplayCertificates" size="small" type="primary" @click="handleQuantityClick">
          {{ $t("common.link") }}
        </el-button>
      </div>
    </div>
    <p style="font-size: 11px; padding-top: 10px; padding-bottom: 10px; color: red;" v-if="isMvpVesselPayActive">
      Billing
      will be automatically charged to vessel company's credit card after vessel signs a Certificate of Quantity</p>
    <div style="border: 1px solid #d5dded" class="mt-4"></div>
    <el-table :header-cell-style="isMobileScreen ? getMobileViewHeaderStyle : getHeaderStyle"
      :cell-style="isMobileScreen ? getMobileViewCellStyle : getCellStyle" :data="quantityTableData" style="width: 100%"
      @row-click="handlePdfClick">
      <el-table-column type="index" min-width="30" :label="$t('table.no')" />
      <el-table-column prop="originalName" label="File Name" align="left" min-width="90" />
      <el-table-column label="Signature Status" min-width="120">
        <template slot-scope="scope">
          <div>
            {{ checkSignType(operationType, 0, scope.row) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="link" width="90">
        <template slot-scope="scope">
          <el-button :size="isMobileScreen ? 'mini' : 'small'" type="primary" plain
            @click="handleRemoveLinkClick(scope.row, scope.$index)">
            <span class="remove">{{ $t("btn.remove") }}</span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="statusContainer mt-6 p-4" v-if="quantityTableData.length > 0">
      <div class="left flex-none w-30">Signature Status:</div>
      <div class="flex-grow flex flex-row">
        <div :class="['flex flex-col', sign_type === 2 || sign_type === 3 ? 'active' : '']" style="flex: 0.5">
          <div class="flex justify-center items-center">
            <span class="label">Terminal </span>
            <svg-icon v-if="sign_type === 2 || sign_type === 3" iconClass="done" />
          </div>
          <div class="bar"></div>
        </div>
        <div :class="['flex flex-col', sign_type === 3 ? 'active' : '']" style="flex: 0.5; margin-left: 4px">
          <div class="flex justify-center items-center">
            <span class="label">Vessel </span>
            <svg-icon v-if="sign_type === 3" iconClass="done" />
          </div>
          <div class="bar"></div>
        </div>
      </div>
    </div>
    <div class="head flex justify-between mt-12" v-if="isLoading()">
      <div class="flex items-center">
        <i class="el-icon-tickets" />
        <span class="pl-4" style="color: #82889c; font-size: 13px">
          {{ $t("menu.quality") }}
        </span>
      </div>
      <el-button @click="handleQualityClick" v-if="link && shouldDisplayCertificates" size="small" type="primary">
        {{ $t("common.link") }}
      </el-button>
    </div>
    <p style="font-size: 11px; padding-top: 10px; padding-bottom: 10px; color: red;"
      v-if="isMvpVesselPayActive && isLoading()">Billing
      will be automatically charged to vessel company's credit card after vessel signs a Certificate of Quality</p>
    <div style="border-top: 1px solid #d5dded" class="mt-4" v-if="isLoading()"></div>
    <el-table :header-cell-style="isMobileScreen ? getMobileViewHeaderStyle : getHeaderStyle"
      :cell-style="isMobileScreen ? getMobileViewCellStyle : getCellStyle" :data="qualityTableData" style="width: 100%"
      @row-click="handlePdfClick" v-if="isLoading()">
      <el-table-column type="index" min-width="30" :label="$t('table.no')" />
      <el-table-column prop="originalName" label="File Name" align="left" min-width="80" />

      <el-table-column v-if="link" width="90">
        <template slot-scope="scope">
          <el-button :size="isMobileScreen ? 'mini' : 'small'" type="primary"
            @click="handleRemoveLinkClick(scope.row, scope.$index, 1)" plain>
            <span class="remove">{{ $t("btn.remove") }}</span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="head flex justify-between mt-12" v-if="isLoading()">
      <div class="flex items-center">
        <i class="el-icon-tickets" />
        <span class="pl-4" style="color: #82889c; font-size: 13px">
          {{ $t("menu.billOfLading") }}
        </span>
      </div>
      <div>
        <el-button v-if="link && shouldDisplayCertificates" size="small" type="primary"
          @click="handleBillOfLadingClick">
          {{ $t("common.link") }}
        </el-button>
      </div>
    </div>
    <p style="font-size: 11px; padding-top: 10px; padding-bottom: 10px; color: red;"
      v-if="isMvpVesselPayActive && isLoading()">Billing
      will be automatically charged to vessel company's credit card after vessel signs a Bill of Lading</p>
    <div style="border-top: 1px solid #d5dded" class="mt-4" v-if="isLoading()"></div>
    <el-table :header-cell-style="isMobileScreen ? getMobileViewHeaderStyle : getHeaderStyle"
      :cell-style="isMobileScreen ? getMobileViewCellStyle : getCellStyle" :data="billOfLadingTableData"
      style="width: 100%" @row-click="handlePdfClick" v-if="isLoading()">
      <el-table-column type="index" min-width="30" :label="$t('table.no')" />
      <el-table-column prop="originalName" label="File Name" align="left" min-width="90" />
      <el-table-column label="Signature Status" min-width="120">
        <template slot-scope="scope">
          <div>
            {{ checkSignType(operationType, 2, scope.row) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="link" width="90">
        <template slot-scope="scope">
          <el-button :size="isMobileScreen ? 'mini' : 'small'" type="primary" plain
            @click="handleRemoveLinkClick(scope.row, scope.$index, 2)">
            <span class="remove">{{ $t("btn.remove") }}</span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="statusContainer mt-6 p-4" v-if="billOfLadingTableData.length > 0">
      <div class="left flex-none w-30">Signature Status:</div>
      <div class="flex-grow flex flex-row">
        <div :class="['flex flex-col', sign_type === 3 ? 'active' : '']" style="flex: 1">
          <div class="flex justify-center items-center">
            <span class="label">Vessel </span>
            <svg-icon v-if="sign_type === 3" iconClass="done" />
          </div>
          <div class="bar"></div>
        </div>
      </div>
    </div>

    <el-dialog :width="isMobileScreen ? '95vw' : '90vw'" :visible.sync="dialogVisible" :title="coqDialogTitle">
      <div class="text-right pr-4">
        <el-button type="primary" @click="handleSaveClick" size="small">{{ $t("btn.save") }}</el-button>
      </div>

      <div class="flex h-full p-4" :gutter="isMobileScreen ? 20 : 10">
        <div style="flex: 0.4;overflow-y: auto;">
          <el-table stripe ref="multipleTable" :data="linkList" tooltip-effect="dark" style="width: 100%"
            v-loading="tableLoading" @selection-change="handleTableSelectionChange" @row-click="handleTableRowClick"
            :header-cell-style="isMobileScreen ? getMobileViewHeaderStyle : getHeaderStyle"
            :cell-style="isMobileScreen ? getMobileViewCellStyle : getCellStyle">
            <el-table-column type="selection" width="50"> </el-table-column>
            <el-table-column prop="originalName" :label="$t('common.FileName')" min-width="80" align="left">
            </el-table-column>
            <el-table-column prop="createTime" :label="$t('common.DateCreated')" show-overflow-tooltip min-width="120">
            </el-table-column>
          </el-table>
        </div>
        <div style="flex: 0.6;">
          <pdf-view style="padding: 10px; width: 100%; height: 100%; overflow-y: scroll;" :dialog="false"
            :pdfUrl="pdfViewSrc" v-model="pdfViewSrc" />
        </div>
      </div>
    </el-dialog>

    <el-dialog :title="coqDialogTitle" :visible.sync="showAttachmentDialog" width="500px"
      style="height: 300px; border-radius: 20px;" :close-on-click-modal="false">
      <div class="drag-drop-area" @dragover.prevent="handleDragOver" @drop="handleDrop"
        style="border: 2px dashed #ccc; padding: 20px; text-align: center; cursor: pointer;">
        <p>Drag and drop your PDF file here</p>
        <p>or</p>
        <el-button size="small" type="primary" @click="triggerAttachmentFileUpload">Select File</el-button>
        <input type="file" :id="'attachment-upload-dialog-' + index" accept=".pdf" multiple style="display: none;"
          @change="handleAttachmentSelect" />
      </div>
    </el-dialog>
    <div class="head flex justify-between mt-12" v-if="isLoading()">
      <div class="flex items-center">
        <i class="el-icon-tickets" />
        <span class="pl-4" style="color: #82889c; font-size: 13px">
          Manifest
        </span>
      </div>
      <div>
        <el-button v-if="link && shouldDisplayCertificates" size="small" type="primary" @click="handleManifestClick">
          Upload
        </el-button>
      </div>
    </div>
    <p style="font-size: 11px; padding-top: 10px; padding-bottom: 10px; color: red;"
      v-if="isMvpVesselPayActive && isLoading()">Billing
      will be automatically charged to vessel company's credit card after vessel signs a Manifest</p>
    <div style="border-top: 1px solid #d5dded" class="mt-4" v-if="isLoading()"></div>
    <el-table :header-cell-style="isMobileScreen ? getMobileViewHeaderStyle : getHeaderStyle"
      :cell-style="isMobileScreen ? getMobileViewCellStyle : getCellStyle" :data="manifestTableData" style="width: 100%"
      @row-click="handlePdfClick" v-if="isLoading()">
      <el-table-column type="index" min-width="30" :label="$t('table.no')" />
      <el-table-column prop="originalName" label="File Name" align="left" min-width="90" />
      <el-table-column label="Signature Status" min-width="120">
        <template slot-scope="scope">
          <div>
            {{ checkSignType(operationType, 3, scope.row) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="link" width="90">
        <template slot-scope="scope">
          <el-button :size="isMobileScreen ? 'mini' : 'small'" type="primary" plain
            @click="handleRemoveLinkClick(scope.row, scope.$index, 4)">
            <span class="remove">{{ $t("btn.remove") }}</span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="statusContainer mt-6 p-4" v-if="manifestTableData.length > 0">
      <div class="left flex-none w-30">Signature Status:</div>
      <div class="flex-grow flex flex-row">
        <div :class="['flex flex-col', sign_type === 3 ? 'active' : '']" style="flex: 1">
          <div class="flex justify-center items-center">
            <span class="label">Vessel </span>
            <svg-icon v-if="sign_type === 3" iconClass="done" />
          </div>
          <div class="bar"></div>
        </div>
      </div>
    </div>
    <div class="head flex justify-between mt-12" v-if="isLoading()">
      <div class="flex items-center">
        <i class="el-icon-tickets" />
        <span class="pl-4" style="color: #82889c; font-size: 13px">
          Receipt of Shipping
        </span>
      </div>
      <div>
        <el-button v-if="link && shouldDisplayCertificates" size="small" type="primary" @click="handleShippingClick">
          Upload
        </el-button>
      </div>
    </div>
    <p style="font-size: 11px; padding-top: 10px; padding-bottom: 10px; color: red;"
      v-if="isMvpVesselPayActive && isLoading()">Billing
      will be automatically charged to vessel company's credit card after vessel signs a Receipt of Shipping</p>
    <div style="border-top: 1px solid #d5dded" class="mt-4" v-if="isLoading()"></div>
    <el-table :header-cell-style="isMobileScreen ? getMobileViewHeaderStyle : getHeaderStyle"
      :cell-style="isMobileScreen ? getMobileViewCellStyle : getCellStyle" :data="receiptOfShippingTableData"
      style="width: 100%" @row-click="handlePdfClick" v-if="isLoading()">
      <el-table-column type="index" min-width="30" :label="$t('table.no')" />
      <el-table-column prop="originalName" label="File Name" align="left" min-width="90" />
      <el-table-column label="Signature Status" min-width="120">
        <template slot-scope="scope">
          <div>
            {{ checkSignType(operationType, 4, scope.row) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="link" width="90">
        <template slot-scope="scope">
          <el-button :size="isMobileScreen ? 'mini' : 'small'" type="primary" plain
            @click="handleRemoveLinkClick(scope.row, scope.$index, 6)">
            <span class="remove">{{ $t("btn.remove") }}</span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="statusContainer mt-6 p-4" v-if="receiptOfShippingTableData.length > 0">
      <div class="left flex-none w-30">Signature Status:</div>
      <div class="flex-grow flex flex-row">
        <div :class="['flex flex-col', sign_type === 3 ? 'active' : '']" style="flex: 1">
          <div class="flex justify-center items-center">
            <span class="label">Vessel </span>
            <svg-icon v-if="sign_type === 3" iconClass="done" />
          </div>
          <div class="bar"></div>
        </div>
      </div>
    </div>
    <div class="head flex justify-between mt-12" v-if="isLoading()">
      <div class="flex items-center">
        <i class="el-icon-tickets" />
        <span class="pl-4" style="color: #82889c; font-size: 13px">
          Receipt Of Samples
        </span>
      </div>
      <div>
        <el-button v-if="link && shouldDisplayCertificates" size="small" type="primary" @click="handleSamplesClick">
          Upload
        </el-button>
      </div>
    </div>
    <p style="font-size: 11px; padding-top: 10px; padding-bottom: 10px; color: red;"
      v-if="isMvpVesselPayActive && isLoading()">Billing
      will be automatically charged to vessel company's credit card after vessel signs a Receipt Of Samples</p>
    <div style="border-top: 1px solid #d5dded" class="mt-4" v-if="isLoading()"></div>
    <el-table :header-cell-style="isMobileScreen ? getMobileViewHeaderStyle : getHeaderStyle"
      :cell-style="isMobileScreen ? getMobileViewCellStyle : getCellStyle" :data="receiptOfSamplesTableData"
      style="width: 100%" @row-click="handlePdfClick" v-if="isLoading()">
      <el-table-column type="index" min-width="30" :label="$t('table.no')" />
      <el-table-column prop="originalName" label="File Name" align="left" min-width="90" />
      <el-table-column label="Signature Status" min-width="120">
        <template slot-scope="scope">
          <div>
            {{ checkSignType(operationType, 5, scope.row) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="link" width="90">
        <template slot-scope="scope">
          <el-button :size="isMobileScreen ? 'mini' : 'small'" type="primary" plain
            @click="handleRemoveLinkClick(scope.row, scope.$index, 5)">
            <span class="remove">{{ $t("btn.remove") }}</span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="statusContainer mt-6 p-4" v-if="receiptOfSamplesTableData.length > 0">
      <div class="left flex-none w-30">Signature Status:</div>
      <div class="flex-grow flex flex-row">
        <div :class="['flex flex-col', sign_type === 3 ? 'active' : '']" style="flex: 1">
          <div class="flex justify-center items-center">
            <span class="label">Vessel </span>
            <svg-icon v-if="sign_type === 3" iconClass="done" />
          </div>
          <div class="bar"></div>
        </div>
      </div>
    </div>
    <div class="head flex justify-between mt-12" v-if="isLoading()">
      <div class="flex items-center">
        <i class="el-icon-tickets" />
        <span class="pl-4" style="color: #82889c; font-size: 13px">
          Certificate of Origin
        </span>
      </div>
      <div>
        <el-button v-if="link && shouldDisplayCertificates" size="small" type="primary" @click="handleOriClick">
          Upload
        </el-button>
      </div>
    </div>
    <p style="font-size: 11px; padding-top: 10px; padding-bottom: 10px; color: red;"
      v-if="isMvpVesselPayActive && isLoading()">Billing
      will be automatically charged to vessel company's credit card after vessel signs a Certificate of Origin</p>
    <div style="border-top: 1px solid #d5dded" class="mt-4" v-if="isLoading()"></div>
    <el-table :header-cell-style="isMobileScreen ? getMobileViewHeaderStyle : getHeaderStyle"
      :cell-style="isMobileScreen ? getMobileViewCellStyle : getCellStyle" :data="certOfOriTableData"
      style="width: 100%" @row-click="handlePdfClick" v-if="isLoading()">
      <el-table-column type="index" min-width="30" :label="$t('table.no')" />
      <el-table-column prop="originalName" label="File Name" align="left" min-width="90" />
      <el-table-column label="Signature Status" min-width="120">
        <template slot-scope="scope">
          <div>
            {{ checkSignType(operationType, 6, scope.row) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="link" width="90">
        <template slot-scope="scope">
          <el-button :size="isMobileScreen ? 'mini' : 'small'" type="primary" plain
            @click="handleRemoveLinkClick(scope.row, scope.$index, 3)">
            <span class="remove">{{ $t("btn.remove") }}</span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="statusContainer mt-6 p-4" v-if="certOfOriTableData.length > 0">
      <div class="left flex-none w-30">Signature Status:</div>
      <div class="flex-grow flex flex-row">
        <div :class="['flex flex-col', sign_type === 2 || sign_type === 3 ? 'active' : '']" style="flex: 1">
          <div class="flex justify-center items-center">
            <span class="label">Terminal </span>
            <svg-icon v-if="sign_type === 2 || sign_type === 3" iconClass="done" />
          </div>
          <div class="bar"></div>
        </div>
      </div>
    </div>
    <div class="head flex justify-between mt-12">
      <div class="flex items-center">
        <i class="el-icon-tickets" />
        <span class="pl-4" style="color: #82889c; font-size: 13px">
          {{ $t("menu.sds") }}
        </span>
      </div>
    </div>
    <div style="border-top: 1px solid #d5dded" class="mt-4"></div>
    <el-table :data="sdsTableData" :header-cell-style="isMobileScreen ? getMobileViewHeaderStyle : getHeaderStyle"
      :cell-style="isMobileScreen ? getMobileViewCellStyle : getCellStyle" style="width: 100%"
      @row-click="handlePdfClick">
      <el-table-column type="index" min-width="30" :label="$t('table.no')" />
      <el-table-column prop="originalName" label="File Name" align="left" min-width="80" />
    </el-table>
    <no-data v-if="sdsTableData.length === 0" />
    <pdf-view v-if="operationData.src" :title="pdfViewTitle" :pdfUrl="operationData.src" v-model="showPdfView" />
  </div>
</template>

<script>
import PdfView from "@/components/common/pdf-view.vue";
import {
  addBoatLink,
  boatListFile,
  getCoqList,
  deleteBoatFile,
  getCQList,
  getBlList,
  getSdsFileByNomId,
  uploadOtherFile,
  getCQVesselList,
  getSdsFileByOpsId
} from "@/services";
import { uploadBl, uploadCq } from "@/services/form";
import { mapState } from "vuex";
import SvgIcon from "@/components/SvgIcon.vue";
import { getCellStyle, getMobileViewCellStyle, getMobileViewHeaderStyle, getHeaderStyle } from "@/utils/getCellStyle";
export default {
  props: {
    // 驳船订单id
    bid: {
      default: null,
    },
    // link状态
    status: {
      type: Number,
      default: 1,
    },
    // 签名类型
    sign_type: {
      type: Number,
      default: null,
    },
    operationId: {
      type: String,
    },
    operationType: {
      type: String
    }
  },
  data() {
    return {
      billOfLadingTableData: [],
      receiptOfSamplesTableData: [],
      receiptOfShippingTableData: [],
      manifestTableData: [],
      certOfOriTableData: [],
      quantityTableData: [],
      qualityTableData: [],
      multipleSelection: [],
      dialogVisible: false,
      coqDialogTitle: 'Link Certificates',
      linkCoqList: [],
      linkCqlist: [],
      linkBlList: [],
      linkManiList: [],
      linkShipList: [],
      linkSampleList: [],
      linkOriList: [],
      pdfViewSrc: "",
      // 0->coq 1->cq 2->bl
      linkType: 0,
      selection: [],
      linkList: [],
      link: false,
      showPdfView: false,
      operationData: {
        src: "",
      },
      tableLoading: true,
      sdsTableData: [],
      showAttachmentDialog: false,
      dragActive: false,
      selectedAttachment: null,
      deleteFileIds: "",
    };
  },
  components: { PdfView, SvgIcon },
  computed: {
    ...mapState(["userInfo", "screenType"]),
    ...mapState(["mvpVesselPayFlag"]),
    shouldDisplayCertificates() {
      return process.env.VUE_APP_SHOW_CERTIFICATES == "true" || process.env.VUE_APP_SHOW_CERTIFICATES === true;
    },
    isMvpVesselPayActive() {
      return this.mvpVesselPayFlag == '0';
    },
    isMobileScreen() {
      return this.screenType?.isMobileScreen ?? false;
    }
  },
  watch: {
    bid(val) {
      if (!isNaN(val)) {
        this.getLinkList();
        this.getBoatListFile();
      }
    },
    sign_type: {
      handler() {
        if (
          (this.sign_type == 1 || this.sign_type == 0 || this.sign_type == null) &&
          (this.isCCR() || this.isLeader())
        ) {
          this.link = true;
        }
        if (this.sign_type == 2 || this.sign_type == 3) {
          this.link = false;
        }
      },
      immediate: true,
    },
    quantityTableData: {
      handler() {
        this.$emit("lists");
      },
    },
    qualityTableData: {
      handler() {
        this.$emit("lists");
      },
    },
  },
  created() {
    if (!isNaN(this.bid)) {
      this.getLinkList();
      this.getBoatListFile();
    }
    this.$emit("lists");
  },
  mounted() {
  },
  methods: {
    getMobileViewHeaderStyle,
    getHeaderStyle,
    getCellStyle,
    getMobileViewCellStyle,
    handlePdfClick(item, row, event) {
      let target = event.target;
      if (target.tagName === "BUTTON" || target.classList.contains("remove"))
        return;

      this.operationData = {
        src: process.env.VUE_APP_BASE_API + item.url,
      };

      if (this.quantityTableData.includes(item)) {
        this.pdfViewTitle = "Certificate of Quantity";
      } else if (this.qualityTableData.includes(item)) {
        this.pdfViewTitle = "Certificate of Quality";
      } else if (this.billOfLadingTableData.includes(item)) {
        this.pdfViewTitle = "Bill of Lading";
      } else if (this.manifestTableData.includes(item)) {
        this.pdfViewTitle = "Manifest";
      } else if (this.receiptOfShippingTableData.includes(item)) {
        this.pdfViewTitle = "Receipt of Shipping";
      } else if (this.receiptOfSamplesTableData.includes(item)) {
        this.pdfViewTitle = "Receipt of Samples";
      } else if (this.certOfOriTableData.includes(item)) {
        this.pdfViewTitle = "Certificate of Origin";
      } else if (this.sdsTableData.includes(item)) {
        this.pdfViewTitle = "SDS Certificate";
      } else {
        this.pdfViewTitle = this.$t("ifm.ViewCertificate");
      }

      this.showPdfView = true;
    },
    // getCellStyle({ rowIndex }) {
    //   if (rowIndex % 2 === 1) {
    //     return {
    //       backgroundColor: "rgba(255,255,255,0.2)",
    //     };
    //   } else {
    //     return {
    //       backgroundColor: "rgba(228,228,228,0.2)",
    //     };
    //   }
    // },

    handleDragOver(event) {
      this.dragActive = true;
    },
    handleDrop(event) {
      this.dragActive = false;
      const files = Array.from(event.dataTransfer.files).filter(f => f.type === 'application/pdf');
      files.forEach(file => {
        this.handleFile(file);
      });
    },
    handleFile(file) {
      if (file && file.type === 'application/pdf') {

        const formData = new FormData();
        formData.append("bId", this.bid);
        formData.append("operationId", this.operationId);

        if (this.linkType == 0) {
          formData.append("file", file);
          uploadCq(formData).then(() => {
            this.showAttachmentDialog = false;
            this.$message.success(this.$t("status.success"));
            this.getBoatListFile();
          }).catch(() => {
            this.$message.error("File upload failed.");
          });
        } else if (this.linkType == 2) {
          formData.append("file", file);
          uploadBl(formData).then(() => {
            this.showAttachmentDialog = false;
            this.$message.success(this.$t("status.success"));
            this.getBoatListFile();
          }).catch(() => {
            this.$message.error("File upload failed.");
          });
        } else {
          formData.append("type", this.linkType);
          formData.append("files", file);
          uploadOtherFile(formData).then(() => {
            this.dialogVisible = false;
            this.showAttachmentDialog = false;
            this.$message.success(this.$t("status.success"));
            this.getBoatListFile();
          }).catch(() => {
            this.$message.error("File upload failed.");
          });
        }

      } else if (file) {
        this.$message.warning("Please upload a valid PDF file.");
      }
    },

    triggerAttachmentFileUpload() {
      document.getElementById(`attachment-upload-dialog-${this.index}`).click();
    },
    handleAttachmentSelect(event) {
      const files = Array.from(event.target.files);
      files.forEach(file => {
        this.handleFile(file);
      });
    },
    handleSaveClick() {
      // coq 上传附件
      if (!this.selection.length) return;

      let data = this.selection.map((item) => {
        return {
          bid: this.bid,
          type: this.linkType,
          pid: item.id,
          originalName: item.originalName,
          url: item.url,
          operationId: this.operationId,

        };
      });

      const linkTop = data.filter(item => item.type < 3);

      if (linkTop.length > 0) {
        addBoatLink(linkTop).then(() => {
          this.dialogVisible = false;
          this.$message.success(this.$t("status.success"));
          this.getBoatListFile();
        });
      }

    },
    checkSignType(operationType, linkType, data) {
      if (operationType === "Loading") {
        const isCRSign = linkType == 2 || linkType == 4 || linkType == 5 || linkType == 3;
        const isLeaderSign = linkType == 6
        const isBothSign = linkType == 0;
        if (isLeaderSign) {
          if (this.sign_type === 2 || this.sign_type === 3) {
            return "Signed";
          } else if (this.sign_type === 0 || this.sign_type === 1) {
            return "Require Signature From JPUT";
          }
        } else if (isCRSign) {
          if (data.mvpDocId && data.mvpDocIsSigned == 1 || this.sign_type === 3) {
            return "Signed";
          } else {
            return "Require Signature From Vessel";
          }
        } else if (isBothSign) {
          if (data.mvpDocId && data.mvpDocIsSigned == 1) {
            return "Signed";
          } else if (this.sign_type === 2) {
            return "Require Signature From Vessel";
          } else if (this.sign_type === 0 || this.sign_type === 1) {
            return "Require Signature From JPUT";
          }
        } else {
          return "Require Signature From JPUT";
        }
      } else {
        if (this.sign_type === 2) {
          return "Signed";
        } else if (this.sign_type === 0 || this.sign_type === 1) {
          return "Require Signature From JPUT";
        }
      }
    },
    getBoatListFile() {
      if (!this.bid) return;

      boatListFile({ BId: this.bid, operationId: this.operationId }).then((res) => {
        this.quantityTableData = res.rows.filter(row => row["type"] === 0);
        this.qualityTableData = res.rows.filter(row => row["type"] === 1);
        this.billOfLadingTableData = res.rows.filter(row => row["type"] === 2);
        this.manifestTableData = res.rows.filter(row => row["type"] === 4);
        this.receiptOfShippingTableData = res.rows.filter(row => row["type"] === 6);
        this.receiptOfSamplesTableData = res.rows.filter(row => row["type"] === 5);
        this.certOfOriTableData = res.rows.filter(row => row["type"] === 3);
      });

      // Separate call to get SDS
      getSdsFileByOpsId(this.bid, this.operationId).then((res) => {
        if (res.data && Array.isArray(res.data)) {
          this.sdsTableData = res.data.map((item, index) => {
            return {
              ...item,
              index: index + 1,
              originalName: item.originalFileName,
              url: item.documentUrl,
            };
          });
        } else {
          this.sdsTableData = [];
        }
      }).catch(() => {
        this.sdsTableData = [];
      });
    },
    getLinkList(type = 0) {
      if (!this.bid) return;
      getCoqList({ id: this.bid, status: 0 }).then((res) => {
        this.linkCoqList = this.handleUrl(res.rows);
        if (type === 0) {
          this.linkList = this.linkCoqList.slice();
          this.tableLoading = false;
        }
      });
      getCQVesselList(this.operationId).then((res) => {
        this.linkCqList = this.handleUrl(res.data);
        if (type === 1) {
          this.linkList = this.linkCqList.slice();
          this.tableLoading = false;
        }
      });
      getBlList({ id: this.bid, status: 0 }).then((res) => {
        this.linkBlList = this.handleUrl(res.rows);
        if (type === 2) {
          this.linkList = this.linkBlList.slice();
          this.tableLoading = false;
        }
      })


      if (this.statu == 4) {
        this.link = false;
      }
      if (
        (this.sign_type == 1 || this.sign_type == 0 || this.sign_type == null) &&
        (this.isCCR())
      ) {
        this.link = true;
      }
      if (this.sign_type == 2 || this.sign_type == 3) {
        this.link = false;
      }
    },
    isDischarge() {
      return this.operationType == 'Discharge'
    },
    isLoading() {
      return this.operationType == 'Loading'
    },
    isLeader() {
      return this.userInfo.userType == 1 && this.userInfo.role == 3
    },
    isCCR() {
      return this.userInfo.userType == 1 && this.userInfo.role == 2
    },
    handleTableSelectionChange(val) {
      this.selection = val;
      let last = this.selection[this.selection.length - 1];
      if (last) {
        this.pdfViewSrc = last.src;
      } else {
        this.pdfViewSrc = "";
      }
    },
    handleTableRowClick(row) {
      this.pdfViewSrc = row.src;
    },
    handleUrl(rows) {
      return rows.map((row) => {
        return { ...row, src: process.env.VUE_APP_BASE_API + row.url };
      });
    },
    handleQuantityClick() {
      this.linkType = 0;
      this.coqDialogTitle = "Certificate of Quantity";
      this.showAttachmentDialog = true;
    },
    handleQualityClick() {
      this.pdfViewSrc = this.linkCqlist[0]?.src;
      this.linkType = 1;
      this.coqDialogTitle = this.$t('table.Lcoq')
      this.dialogVisible = true;
      this.linkList = [];
      this.tableLoading = true;
      this.getLinkList(1);
    },
    handleBillOfLadingClick() {
      this.linkType = 2;
      this.coqDialogTitle = "Bill of Lading";
      this.showAttachmentDialog = true;
    },

    handleManifestClick() {
      this.linkType = 4;
      this.pdfViewSrc = this.linkManiList[0]?.src;
      this.coqDialogTitle = 'Manifest';
      this.showAttachmentDialog = true;
      this.getLinkList(3);
    },

    handleShippingClick() {
      this.linkType = 6;
      this.pdfViewSrc = this.linkShipList[0]?.src;
      this.coqDialogTitle = 'Receipt of Shipping';
      this.showAttachmentDialog = true;
      this.getLinkList(4);
    },

    handleSamplesClick() {
      this.linkType = 5;
      this.pdfViewSrc = this.linkSampleList[0]?.src;
      this.coqDialogTitle = 'Receipt of Samples';
      this.showAttachmentDialog = true;
      this.getLinkList(5);
    },

    handleOriClick() {
      this.linkType = 3;
      this.pdfViewSrc = this.linkOriList[0]?.src;
      this.coqDialogTitle = 'Certificate of Origin';
      this.showAttachmentDialog = true;
      this.getLinkList(6);
    },

    handleRemoveLinkClick(item, index, type = 0) {
      deleteBoatFile(item.id).then(() => {
        this.$message.success(this.$t("status.success"));
        if (type == 0) {
          this.quantityTableData.splice(index, 1);
        } else if (type == 1) {
          this.qualityTableData.splice(index, 1);
        } else if (type == 2) {
          this.billOfLadingTableData.splice(index, 1);
        } else if (type == 3) {
          this.certOfOriTableData.splice(index, 1);
        } else if (type == 4) {
          this.manifestTableData.splice(index, 1);
        } else if (type == 5) {
          this.receiptOfSamplesTableData.splice(index, 1);
        } else if (type == 6) {
          this.receiptOfShippingTableData.splice(index, 1);
        }
      });

    },
    handlePreviewClick() { },
    selectSequence(index) {
      this.selectedIndex = index;
      // Trigger any additional logic like loading details
    }
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-table::before {
  height: 0;
}

.Cerload {
  display: flex;
}

::v-deep .el-dialog__header {
  padding-bottom: 5px !important;
}

::v-deep .el-dialog__body {
  height: 80vh;
  padding-top: 10px;
}

::v-deep .el-dialog {
  margin-top: 5vh !important;
  margin-bottom: 0px !important;
}

.statusContainer {
  border: 1px solid #dfe1e7;

  .left {
    font-size: 12px;
    color: #82889c;
    font-weight: 600;
    line-height: 150%;
  }

  .active {
    .bar {
      background: #25cf36;
    }

    .label {
      color: #25cf36;
    }
  }

  .bar {
    height: 5px;
    background: #dedede;
  }

  .label {
    font-weight: 500;
    font-size: 13px;
    line-height: 26px;
    color: #dedede;
  }

  .svg-icon {
    width: 12px;
    height: 10px;
    margin-left: 5px;
  }
}

::v-deep .el-table__cell>.cell {
  padding-left: 3px;
  padding-right: 2px;

  b {
    word-break: keep-all;
  }
}

::v-deep th.el-table__cell>.cell {
  padding-left: 3px;
  padding-right: 1px;

  b {
    word-break: keep-all;
  }

}

.sequences-wrapper {
  display: flex;
  overflow-x: auto;
  padding: 10px;
  background-color: #f8f9fa;
  margin-bottom: 14px;
}


.sequence-card {
  min-width: 120px;
  margin-right: 8px;
  padding: 10px;
  border-radius: 6px;
  background: white;
  border: 2px solid transparent;
  cursor: pointer;
  text-align: center;
  font-size: 14px;
}

.sequence-card.selected {
  border-color: #007bff;
  border-bottom: 4px solid #007bff;
}

.title {
  font-weight: bold;
  margin-bottom: 4px;
}

.operation {
  color: #555;
}

.quantity {
  font-size: 14px;
  margin-bottom: 4px;
}

.location {
  font-size: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.dot {
  height: 8px;
  width: 8px;
  border-radius: 50%;
  margin-right: 6px;
  background-color: gray;
}

.dot.terminal {
  background-color: green;
}

.dot.vessel {
  background-color: blue;
}

.radio-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.radio-group.single-option {
  flex-direction: row;
}

.custom-radio {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  color: #333;
}

.custom-radio input[type="radio"] {
  display: none;
}

.radio-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid #00c853;
  /* green border */
  margin-right: 8px;
  position: relative;
}

.custom-radio input[type="radio"]:checked+.radio-dot::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 6px;
  height: 6px;
  background-color: #00c853;
  /* green fill */
  border-radius: 50%;
}
</style>
